import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { OPZET_API_URL } from '../../../config/constants';
import { AddressFull } from '../../../types/opzet';
import { AddressQueryFnParameters } from '../../../containers/AddressSelection/types';
import { CalendarItem } from '../../../../apps/waste-calendar/types';
import { fetchCalendarItems } from '../../../../apps/waste-calendar/api/calendar';

// Define a service using a base URL and expected endpoints
export const opzetApi = createApi({
  reducerPath: 'opzetApi',
  baseQuery: fetchBaseQuery({ baseUrl: OPZET_API_URL }),
  endpoints: (builder) => ({
    getCalendarItems: builder.query<CalendarItem[], string>({
      queryFn: async (bagId, queryApi, extraOptions, baseQuery) => {
        try {
          const items = await fetchCalendarItems(bagId, baseQuery);
          return {
            data: items,
          };
        } catch (error) {
          return {
            error: {
              status: 500,
              statusText: 'Something went wrong whilst fetching the calendar items.',
              data: error,
            },
          };
        }
      },
    }),
    addressSuggest: builder.query<AddressFull[], AddressQueryFnParameters>({
      query: ({ postal_code, housenumber }) => ({
        url: `/adressen/${postal_code}:${housenumber}`,
      }),
    }),
  }),
});

